var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteWrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.447 2.51795C12.9021 2.31699 12.3006 2.60929 12.1052 3.17064C11.9099 3.73198 12.194 4.3498 12.7398 4.55075C15.7172 5.6477 17.7169 8.57069 17.7169 11.825C17.7169 16.0841 14.348 19.5493 10.2072 19.5493C6.06642 19.5493 2.69744 16.0841 2.69744 11.825C2.69744 9.90098 3.38932 8.05667 4.64633 6.63421C5.62319 5.52813 6.87617 4.74756 8.25508 4.36641V5.44675C8.25508 5.55719 8.37618 5.62196 8.46418 5.55802L11.5118 3.33672C11.5861 3.28274 11.5861 3.16898 11.5118 3.115L8.46418 0.8937C8.37618 0.829759 8.25508 0.8937 8.25508 1.00497V2.14759C6.27551 2.5686 4.46872 3.62403 3.09222 5.18268C1.48403 7.00374 0.598389 9.36288 0.598389 11.8258C0.598389 17.2757 4.90871 21.7092 10.2072 21.7092C15.5057 21.7092 19.816 17.2757 19.816 11.8258C19.816 7.66224 17.2568 3.92215 13.447 2.51878V2.51795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWrap);
export default __webpack_public_path__ + "static/media/whiteWrap.1316c99d75e68d97822bf751349229ed.svg";
export { ForwardRef as ReactComponent };